export type DirtyFieldsType =
  | {
      [key: string]: DirtyFieldsType;
    }
  | boolean
  | null
  | DirtyFieldsType[];

// biome-ignore lint/suspicious/noExplicitAny: <in this funciton you can have any sort of types>
export const getDirtyValues = <T extends Record<string, any>>(
  dirtyFields: Partial<Record<keyof T, DirtyFieldsType>>,
  values: T,
  nested: boolean = true
): Partial<T> => {
  const dirtyValues = Object.keys(dirtyFields).reduce(
    (prev, key) => {
      const value = dirtyFields[key];
      if (!value) {
        return prev;
      }
      const isObject = typeof value === "object";
      const isArray = Array.isArray(value);
      const nestedValue =
        isObject && !isArray && nested
          ? // biome-ignore lint/suspicious/noExplicitAny: <in this funciton you can have any sort of types>
            getDirtyValues(value as Record<string, any>, values[key])
          : values[key];
      return { ...prev, [key]: isArray ? values[key] : nestedValue };
    },
    {} as Partial<T>
  );
  return dirtyValues;
};
